import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Omega3GellulesImage from '../../../assets/omega3/Omega-3 gellules.webp';

const Omega3HowToSection = () => {
  const { t } = useTranslation();

  return (
    <section className="t-bg-surface t-py-16 md:t-py-20">
      <div className="container !t-max-w-[1200px]">
        <div className="t-flex t-flex-col md:t-flex-row t-items-center t-justify-between t-gap-8 g:t-gap-16">
          <h2
            className="!t-m-0 t-text-[34px] lg:t-text-[42px] t-leading-[1.08] t-text-navy t-text-center"
            style={{ fontFamily: 'DM Serif Display, serif' }}
          >
            <Trans
              i18nKey="Omega3_HowTo_HeadlineHtml"
              components={{ em: <em className="!t-text-quiz-teal t-not-italic" /> }}
            />
          </h2>

          <img
            src={Omega3GellulesImage}
            alt={t('Omega3_HowTo_Image_Alt')}
            className="t-h-[280px] t-w-auto md:t-h-[280px]"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default Omega3HowToSection;
